/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_APPLICATION_ID_DETAILS_REQUEST,
  FETCH_APPLICATION_ID_DETAILS_SUCCESS,
  FETCH_APPLICATION_ID_DETAILS_FAILURE,
} from "./AppIdDetailsTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchApplicationIdDetailsRequest = () => {
  return {
    type: FETCH_APPLICATION_ID_DETAILS_REQUEST,
  };
};

export const fetchApplicationIdDetailsSuccess = (appData) => {
  return {
    type: FETCH_APPLICATION_ID_DETAILS_SUCCESS,
    payload: appData,
  };
};

export const fetchApplicationIdDetailsFailure = (error) => {
  return {
    type: FETCH_APPLICATION_ID_DETAILS_FAILURE,
    payload: error,
  };
};

export const fetchApplicationDetails = (applicationId) => {
  return async function (dispatch) {
    dispatch(fetchApplicationIdDetailsRequest());
    try {
      const data = await APIManager.getApplication(applicationId);
      dispatch(fetchApplicationIdDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchApplicationIdDetailsFailure(error));
      dispatch(commonError(error, FETCH_APPLICATION_ID_DETAILS_FAILURE));
    }
  };
};

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}
